import { Input, Popover } from '@any-ui-react/core';
import { MonthPicker as MantineMonthPicker } from '@mantine/dates';
import { format, parse } from 'date-fns';
import { useState } from 'react';

import { DATETIME_FORMATS, DateUtils } from '@/common/utils';

interface Props {
  allowDeselect?: boolean;
  disabled?: boolean;
  label?: string;
  maxDate?: Date;
  maxLevel?: 'year' | 'decade';
  minDate?: Date;
  required?: boolean;
  value: string;
  withinPortal?: boolean;
  onChange: (value: string) => void;
}

export const MonthPicker = ({
  allowDeselect,
  disabled,
  label,
  maxDate,
  maxLevel,
  minDate,
  required,
  value,
  withinPortal,
  onChange,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover
      closeOnClickOutside={true}
      disabled={disabled}
      offset={0}
      opened={isOpen}
      position="bottom-start"
      withinPortal={withinPortal}
      onChange={setIsOpen}
    >
      <Popover.Target>
        <Input.Wrapper onClick={() => setIsOpen(prev => !prev)}>
          {label && <Input.Label required={required}>{label}</Input.Label>}
          <Input
            classNames={{ input: 'text-center cursor-pointer' }}
            disabled={disabled}
            readOnly={true}
            value={DateUtils.formatDate(parse(value, DATETIME_FORMATS.yyyyMM, new Date()), DATETIME_FORMATS.yyyyMM)}
          />
        </Input.Wrapper>
      </Popover.Target>
      <Popover.Dropdown className="absolute max-h-[26rem] rounded border border-gray-2 bg-white shadow-sm">
        <MantineMonthPicker
          allowDeselect={allowDeselect}
          className="bg-white"
          defaultDate={DateUtils.coalesce(value)}
          maxDate={maxDate}
          maxLevel={maxLevel}
          minDate={minDate}
          value={DateUtils.coalesce(value)}
          onChange={v => {
            if (v) {
              onChange(format(v, 'yyyy-MM'));
              setIsOpen(false);
            }
          }}
        />
      </Popover.Dropdown>
    </Popover>
  );
};
